import { Box, css, Grid, useTheme } from '@mui/material'

import { useMQ } from '../hooks/useMQ'
import { BlurBox } from './BlurBox'
import { HumaScrollAnimation } from './HumaScrollAnimation'
import BuiltForArchitecture from './images/built-for-architecture.png'
import BuiltForCompliance from './images/built-for-compliance.png'
import BuiltForLiquidity from './images/built-for-liquidity.png'
import BuiltForRisk from './images/built-for-risk.png'
import { Title } from './Title'

export function HumaDifference() {
  const theme = useTheme()
  const { isXsSize, isMdSize } = useMQ()

  const features: {
    title: string
    description: string
    image: string
  }[] = [
    {
      title: 'Instant Liquidity',
      description:
        'Access funds immediately with our seamless and efficient liquidity solutions.',
      image: BuiltForLiquidity,
    },
    {
      title: 'Built-in Risk Management',
      description:
        'Principle safety through world-class risk management, and structured finance enforced by smart contracts.',
      image: BuiltForRisk,
    },
    {
      title: 'Compliant',
      description:
        'Strong compliance requirements including comprehensive AML screenings, and investor status checks.',
      image: BuiltForCompliance,
    },
    {
      title: 'Open Architecture',
      description:
        'Benefit from cross-layer interoperability and modular design to create customized financing solutions tailored to your needs.',
      image: BuiltForArchitecture,
    },
  ]

  const styles = {
    wrapper: css`
      margin-top: ${isMdSize ? '72px' : '160px'};
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      width: ${isMdSize ? '100%' : '1200px'};
    `,
    impactWrapper: css`
      box-sizing: border-box;
      height: ${isXsSize ? 'fit-content' : '320px'};
      display: flex;
      padding: ${isXsSize ? '24px 16px' : '40px'};
      flex-direction: column;
      justify-content: space-between;
      line-height: 32px;
      color: ${theme.palette.secondary.main};
      width: 100%;
    `,
    imageWrapper: css`
      display: flex;
      justify-content: flex-end;
    `,
    image: css`
      height: ${isXsSize ? '60px' : '96px'};
      width: ${isXsSize ? '60px' : '96px'};
    `,
    title: css`
      font-family: 'Red-Hat-Display';
      color: #cecece;
      font-size: ${isXsSize ? '16px' : '24px'};
      font-weight: 700;
      line-height: 50px;
      letter-spacing: 0.46px;
    `,
    description: css`
      font-size: ${isXsSize ? '14px' : '18px'};
      color: #848484;
      font-weight: 400;
      line-height: 150%;
      letter-spacing: 0.15px;
    `,
  }

  return (
    <HumaScrollAnimation>
      <Box css={styles.wrapper}>
        <Title title='The Huma Difference' />
        <Grid container spacing={isXsSize ? 2 : 6}>
          {features.map((item) => (
            <Grid item sm={12} md={6} key={item.title}>
              <BlurBox
                key={item.title}
                fadedBorder
                extraStyles={styles.impactWrapper}
              >
                <Box css={styles.imageWrapper}>
                  <img src={item.image} css={styles.image} alt='industry' />
                </Box>
                <Box>
                  <Box css={styles.title}>{item.title}</Box>
                  <Box css={styles.description}>{item.description}</Box>
                </Box>
              </BlurBox>
            </Grid>
          ))}
        </Grid>
      </Box>
    </HumaScrollAnimation>
  )
}
